export const MAX_RESOURCE_SELECTION = 50
